// Compatible with Create React App / Webpack: rely solely on NODE_ENV
// This avoids using import.meta which breaks in babel/webpack pipelines.
export const IS_PROD: boolean =
  typeof process !== 'undefined' &&
  !!(process as any).env &&
  (process as any).env.NODE_ENV === 'production';

// Enable runtime debug features (DebugPanel, GridDebugView, verbose logs)
// Set REACT_APP_DEBUG=true in your environment to turn on
// Primary: build-time flag (CRA)
const DEBUG_ENV: boolean =
  typeof process !== 'undefined' &&
  !!(process as any).env &&
  String((process as any).env.REACT_APP_DEBUG || '').toLowerCase() === 'true';

// Runtime overrides: query string or localStorage (helps when env var is hard to pass in hosting)
// - ?debug=1 enables debug for that session
// - localStorage.setItem('letterweave_debug', 'true') persists across reloads
const DEBUG_RUNTIME: boolean = (() => {
  if (typeof window === 'undefined') return false;
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.has('debug')) return true;
    const stored = (window.localStorage && window.localStorage.getItem('letterweave_debug')) || '';
    return String(stored).toLowerCase() === 'true' || stored === '1';
  } catch {
    return false;
  }
})();

export const IS_DEBUG: boolean = DEBUG_ENV || DEBUG_RUNTIME;

export const ADSENSE_CLIENT: string | undefined =
  typeof process !== 'undefined' && (process as any).env
    ? (process as any).env.REACT_APP_ADSENSE_CLIENT
    : undefined;

export const ADSENSE_SLOT: string | undefined =
  typeof process !== 'undefined' && (process as any).env
    ? (process as any).env.REACT_APP_ADSENSE_SLOT
    : undefined;

// Leaderboard API URL - automatically selects local or production based on environment
// In development: uses localhost:3001
// In production: uses REACT_APP_LEADERBOARD_API_URL if set, otherwise uses default production URL
export const getLeaderboardApiUrl = (): string | undefined => {
  // If explicitly set via env var, use that (allows override)
  const explicitUrl = typeof process !== 'undefined' && (process as any).env
    ? (process as any).env.REACT_APP_LEADERBOARD_API_URL
    : undefined;
  
  if (explicitUrl) {
    return explicitUrl;
  }
  
  // Check hostname first (runtime check) - most reliable way to detect local vs production
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const isLocalhost = hostname === 'localhost' || 
                       hostname === '127.0.0.1' ||
                       hostname === '' ||
                       hostname.startsWith('192.168.') ||
                       hostname.startsWith('10.') ||
                       hostname.startsWith('172.16.');
    
    if (isLocalhost) {
      return 'http://localhost:3001/api/leaderboard';
    }
  }
  
  // If not localhost, use production API URL
  // This covers production builds deployed to Render, Vercel, etc.
  return 'https://letterweave-api.onrender.com/api/leaderboard';
};

